/* import __COLOCATED_TEMPLATE__ from './footer-message.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./footer-message.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  classNames: ["footer-message"]
}));